import React from 'react';
import { FileText, Zap, Users, ShieldCheck, CreditCard, CheckCircle2 } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-10 pb-8 md:pt-28 md:pb-24 overflow-hidden bg-accent" data-id="element-132">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 pointer-events-none" data-id="element-133">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-primary-light rounded-full mix-blend-multiply filter blur-3xl opacity-70" data-id="element-134"></div>
        <div className="absolute top-1/2 -left-24 w-72 h-72 bg-secondary-light rounded-full mix-blend-multiply filter blur-3xl opacity-70" data-id="element-135"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-136">
        <div className="flex flex-col items-center text-center max-w-4xl mx-auto" data-id="element-137">
          

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-secondary-dark leading-tight mb-4 md:mb-8" data-id="element-138">
            Todo tu año de Gimnasia Rítmica <br className="hidden md:block" data-id="element-139" />
            <span className="text-primary" data-id="element-140">Infantil Resuelto</span>
          </h1>

          {/* Product Image at 80% */}
          <div className="w-[80%] max-w-xl mx-auto mb-4 md:mb-8 relative" data-id="element-141">
            <div className="absolute inset-0 bg-gradient-to-tr from-primary-light to-secondary-light rounded-full transform scale-90 -z-10 blur-2xl opacity-60" data-id="element-142"></div>
            <img src="https://cdn.magicpatterns.com/uploads/qfx6U6DvPJxiTiHM2Cq3tg/heylloyd-image-1776729588328-Photoroom.png" alt="Gimnasia Rítmica Infantil Resuelta - 6 Tomos y Bonos" className="w-full h-auto drop-shadow-2xl object-contain" data-id="element-143" />
          </div>

          <p className="text-base md:text-lg text-gray-700 mb-5 md:mb-8 max-w-xl leading-relaxed" data-id="element-144">
            Tu año completo de clases de gimnasia rítmica infantil listo:
            fundamentos, aparatos, coreografía, planificación por niveles,
            gestión y mucho más.{' '}
            <strong className="text-secondary-dark font-semibold" data-id="element-145">
              Sin improvisar nunca más.
            </strong>
          </p>

          <div className="grid grid-cols-2 gap-2 md:gap-3 mb-5 md:mb-8 w-full max-w-md" data-id="element-146">
            <div className="flex items-center gap-1.5 md:gap-2 text-xs md:text-sm font-medium text-gray-700 bg-white/60 px-2 py-1.5 md:px-3 md:py-2 rounded-lg" data-id="element-147">
              <FileText className="w-3.5 h-3.5 md:w-4 md:h-4 text-primary" data-id="element-148" />{' '}
              PDF digital
            </div>
            <div className="flex items-center gap-1.5 md:gap-2 text-xs md:text-sm font-medium text-gray-700 bg-white/60 px-2 py-1.5 md:px-3 md:py-2 rounded-lg" data-id="element-149">
              <Zap className="w-3.5 h-3.5 md:w-4 md:h-4 text-primary" data-id="element-150" /> Acceso
              inmediato
            </div>
            <div className="flex items-center gap-1.5 md:gap-2 text-xs md:text-sm font-medium text-gray-700 bg-white/60 px-2 py-1.5 md:px-3 md:py-2 rounded-lg" data-id="element-151">
              <Users className="w-3.5 h-3.5 md:w-4 md:h-4 text-primary" data-id="element-152" /> Todos
              los niveles
            </div>
            <div className="flex items-center gap-1.5 md:gap-2 text-xs md:text-sm font-medium text-gray-700 bg-white/60 px-2 py-1.5 md:px-3 md:py-2 rounded-lg" data-id="element-153">
              <ShieldCheck className="w-3.5 h-3.5 md:w-4 md:h-4 text-primary" data-id="element-154" />{' '}
              Garantía 7 días
            </div>
          </div>

          <button onClick={scrollToPricing} className="w-full sm:w-auto bg-primary hover:bg-primary-dark text-white font-bold text-base md:text-lg py-3 md:py-4 px-6 md:px-8 rounded-full shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex items-center justify-center gap-2" data-id="element-155">
            💥 QUIERO MI GIMNASIA RÍTMICA INFANTIL RESUELTA
          </button>

          <div className="flex items-center gap-2 mt-3 md:mt-4 text-xs md:text-sm text-gray-500" data-id="element-156">
            <CreditCard className="w-4 h-4" data-id="element-157" />
            <span data-id="element-158">
              Pago 100% seguro · Mercado Pago | Tarjeta | Transferencia
            </span>
          </div>
        </div>
      </div>

      {/* Social Proof Strip */}
      <div className="w-full bg-white border-y border-gray-100 mt-8 md:mt-16 py-3 md:py-6 relative z-10" data-id="element-159">
        <div className="container mx-auto px-4" data-id="element-160">
          <div className="flex flex-wrap justify-center md:justify-between items-center gap-3 md:gap-4 text-xs md:text-base font-medium text-gray-600" data-id="element-161">
            <div className="flex items-center gap-2" data-id="element-162">
              <Users className="w-5 h-5 text-secondary" data-id="element-163" />
              <span data-id="element-164">+300 profes confían</span>
            </div>
            <div className="hidden md:block w-1 h-1 bg-gray-300 rounded-full" data-id="element-165"></div>
            <div className="flex items-center gap-2" data-id="element-166">
              <FileText className="w-5 h-5 text-secondary" data-id="element-167" />
              <span data-id="element-168">6 Tomos + 6 Bonos</span>
            </div>
            <div className="hidden md:block w-1 h-1 bg-gray-300 rounded-full" data-id="element-169"></div>
            <div className="flex items-center gap-2" data-id="element-170">
              <div className="flex text-yellow-400" data-id="element-171">
                {'★★★★★'.split('').map((star, i) => <span key={i} data-id="element-172">{star}</span>)}
              </div>
              <span data-id="element-173">4.9/5 valoración</span>
            </div>
            <div className="hidden lg:block w-1 h-1 bg-gray-300 rounded-full" data-id="element-174"></div>
            <div className="flex items-center gap-2" data-id="element-175">
              <span className="text-xl" data-id="element-176">🇦🇷</span>
              <span data-id="element-177">Todo el país envío digital</span>
            </div>
          </div>
          <div className="mt-3 md:mt-4 text-sm md:text-base font-semibold text-primary" data-id="element-178">
            Sistema N°1 para Instructoras en Argentina
          </div>
        </div>
      </div>
    </section>;
}